exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3bAnXU22cBFCPJGm4KsgSp{text-align:left}._23W6ND0RmUAjEylbzuw8Dv{background:#6982ff;color:#fff;font-weight:500;padding-top:10px;padding-bottom:10px;padding-left:15px;padding-right:15px;font-size:15px;width:350px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border-radius:4px 4px 0 0}._1O9UFOo2HCwvuT_uduUrxd{font-size:14px;line-height:20px;padding:10px;width:350px;display:flex;flex-direction:row;text-align:left}._13VYkeqkuNIqtWVzwKnBV9{flex:1 0 230px}.kttrCuEjCnj0OAjdSaJOw{flex:1 0 100px;height:100px}._3ZqZl_s9qd1G8pya69EtlT{font-weight:500}\n", ""]);

// Exports
exports.locals = {
	"ClubEventCard": "_3bAnXU22cBFCPJGm4KsgSp",
	"header": "_23W6ND0RmUAjEylbzuw8Dv",
	"content": "_1O9UFOo2HCwvuT_uduUrxd",
	"left": "_13VYkeqkuNIqtWVzwKnBV9",
	"right": "kttrCuEjCnj0OAjdSaJOw",
	"timespan": "_3ZqZl_s9qd1G8pya69EtlT"
};